/* eslint-disable eqeqeq */
import paraMoedaReal from './paraMoedaReal';

function somenteDecimal(valor) {
    let valorTemp;
    valorTemp = isNaN(valor) ? valor : paraMoedaReal(valor, 2);
    if (valorTemp == undefined || valorTemp == '') {
        return;
    }
    let numberPattern = /\d+/g;
    if (valorTemp === 0) {
        return valorTemp;
    }
    let result = valorTemp.match(numberPattern);
    if (result[1] == undefined) {
        return result[0] + '.' + 0;
    } else {
        return result[0] + '.' + result[1];
    }
}

export default somenteDecimal;